export class DeleteViewModel {
    TenantName: string;
    RequestError: string;
    Failed: boolean;
    TenantId: any;
    ProcessComplete: boolean;
}